import { Component, Input } from '@angular/core';

// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
@Component({
    selector: 'app-page',
    template: `
        <article class="page" *ngIf="!notFound">
            <header>
                <app-bg></app-bg>
                <div class="header-placeholder"></div>
                <div class="header-content">
                    <div class="content-column horizontal-layout">
                        <ng-content select="[header]"></ng-content>
                    </div>
                    <app-progress-bar *ngIf="showPageProgressBar"></app-progress-bar>
                </div>
            </header>
            <div class="page-container">
                <main class="mat-app-background formatted">
                    <app-page-toolbar>
                        <ng-content content select="[toolbarContent]"></ng-content>
                        <ng-content left select="[toolbarLeft]"></ng-content>
                        <ng-content right select="[toolbarRight]"></ng-content>
                    </app-page-toolbar>
                    <div class="page-content">
                        <ng-content select="[pageContentNoColumn]"></ng-content>
                        <div class="content-column">
                            <ng-content select="[pageContent]"></ng-content>
                        </div>
                    </div>
                    <ng-content select="[afterContent]"></ng-content>
                    <app-bottom-info *ngIf="showPageClosure"></app-bottom-info>
                    <app-cart-state-bar-space-taker></app-cart-state-bar-space-taker>
                </main>
            </div>
        </article>
        <app-not-found *ngIf="notFound"></app-not-found>
    `,
})
export class PageComponent
{
    // Sections

    @Input() protected showPageProgressBar = false;
    @Input() protected showPageClosure = true;
    @Input() protected notFound = false;
}
